import { Provider } from '@lib/resources/types';
import axiosClient from '@lib/utils/axiosClient';

import { useQuery } from 'react-query';

import { makeResourceKeys } from 'requests/resources/makeResources/makeResourcesKeys';

const providerKey = makeResourceKeys('providers-search');
interface UseProvidersByIDsParams {
  ids: string[];
  [key: string]: unknown;
}
interface IReturnData {
  response: Provider[];
}

const fetchFn = async ({ ids, ...params }: UseProvidersByIDsParams) => {
  const { data } = await axiosClient.get<IReturnData>('/providers/search', {
    params: { ...params, ...(ids.length && { _id: ids.join(',') }) },
  });
  return data.response;
};

export default function useProvidersByIDs(
  { ids, ...params }: UseProvidersByIDsParams,
  { enabled }: { enabled?: boolean },
) {
  const queryResult = useQuery(providerKey.byIds({ ids, ...params }), () => fetchFn({ ids, ...params }), {
    enabled: !!enabled,
  });
  return queryResult;
}
